import StoryImageSeriesController from './story-image-series-controller'

export default class StoryController {
  constructor (element) {
    this._element = element
    this._initImageSeriesControllers()
  }

  _initImageSeriesControllers () {
    const imageSeriesElements = this._element.querySelectorAll('.story__block-image-series__slider')
    ;[].forEach.call(imageSeriesElements, (element) => {
      console.log('initiating image series', element)
      // eslint-disable-next-line no-new
      new StoryImageSeriesController(element)
    })
  }
}
